const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Viraj Bhidola</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Registrations Head, UPES-CSI</li>
    <li>
        Managing event registrations and participant data.
    </li>
    <li>
        Ensuring seamless registration processes.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
